import { fetchState } from '@/store/extensions/fetch';
import { createState } from '@/store/extensions/create';
import { updateState } from '@/store/extensions/update';

import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  ...fetchState,
  ...createState,
  ...updateState,
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/role/index.js